// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"breadcrumbsItem__breadcrumb___17cGZ","active":"breadcrumbsItem__active___2v1rE"};